import { css } from 'emotion';

export const info = theme => css`
  font-size: 16px;
  color: ${theme.color.black1};
  margin-top: 10px;
`;

export const header = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const urlContainer = css`
  margin: 14px 0px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

export const urlInput = css`
  flex: 1;
  width: 100%;
`;

export const actionBtns = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const copyButton = css`
  flex-shrink: 0;
  font-size: 14px !important;
  min-width: 100px !important;
  padding: 0 20px !important;
  svg {
    height: 18px;
    width: 18px;
    margin-right: 4px;
  }
`;

export const cancelBtn = css`
  font-size: 14px !important;
  min-width: 100px !important;
  padding: 0 20px !important;
  svg {
    height: 14px;
    width: 14px;
    margin-right: 4px;
  }
  margin-left: 0px !important;
`;
